import React, { useState, useEffect } from "react";
import { useDispatch,useSelector } from "react-redux";
import { Grid2, Box, Typography, Button, TextField, Alert } from "@mui/material";

import { addWorkspace } from "../../actions/workspaceAction";
import { Link, useNavigate } from 'react-router-dom';

import CustomButton from "../../themes/overrides/Button";

const CreateWorkspace = ({ currentWorkspace }) => {
  const [workspace, setWorkspace] = useState({ name: "" });
  const [success, setSuccess] = useState(false); // For success message
  const error = useSelector((state) => state.workspace.error);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (currentWorkspace) {
      setWorkspace(currentWorkspace);
    }
  }, [currentWorkspace]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setWorkspace((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (currentWorkspace) {
      //update 
    } else {
      dispatch(addWorkspace(workspace,navigate, ()=>{
        setSuccess(true);
        setTimeout(()=>{
          setSuccess(false);
          navigate('/space')
        },3000)
      }));
    }
    setWorkspace({ name: "" });
  };

  return (
    <>
      <Grid2 container>
        <Grid2 size={12}>
          <Grid2 size={12}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                minHeight: "100vh",
              }}
            >
              <Box
                sx={{
                  width: "100%",
                  maxWidth: 500,
                  p: 4,
                  backgroundColor: "#fff",
                  border:'1px solid #EAEAEA',
                  borderRadius:2
                }}
              >
                <Grid2
                  container
                  spacing={2}
                  sx={{
                    display: "flex",
                    alignContent: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <Grid2 size={12}>
                    <Typography variant="body1">Create Workspace</Typography>
                  </Grid2>
                  {
                    success && (
                      <Grid2 size={12}>
                        <Alert severity="success">Workspace created successfully!</Alert>
                      </Grid2>
                    )
                  }
{
                    error && (
                      <Grid2 size={12}>
                        <Alert severity="success">{error}</Alert>
                      </Grid2>
                    )
                  }
                  <Grid2 size={12}>
                    <form onSubmit={handleSubmit}>
                      <TextField
                        label="workspace name"
                        fullWidth
                        required
                        margin="normal"
                        variant="outlined"
                        value={workspace.name}
                        onChange={handleChange}
                        name="name"
                      />
                      {/* <Button
                        type="submit"
                        variant="contained"
                        sx={{ pt: 2, pb: 2 }}
                        color="primary"
                        fullWidth
                      >
                        Create
                      </Button> */}
                      <CustomButton 
                      label="Create"
                      // color="primary"
                      // variant="contained"
                      type="submit"
                      fullWidth
                      sx={{pt:2, pb:2}}
                      />
                      <Button
                        component={Link}
                        to="/space"
                        variant="text"
                        color="primary"
                        sx={{
                          textTransform: "none",
                          textAlign:"right",
                          justifyContent:"flex-end",
                          display:"flex"
                        }}
                      >
                        Back
                      </Button>
                    </form>
                  </Grid2>
                </Grid2>
              </Box>
            </Box>
          </Grid2>
        </Grid2>
      </Grid2>
    </>
  );
};

export default CreateWorkspace;
